import { useState, useEffect } from "react";
import Map from "./Map";
import { router } from "@inertiajs/react";
import Filters from "./Filters";
import AppLayout from "@/layouts/AppLayout";
import CategoriesFilter from "@/components/CategoriesFilter";
import SearchItems from "@/components/SearchItems";
import ItemsGrid from "@/components/ItemsGrid";
import PaginationComp from "@/components/PaginationComp";
import Placeholder from "@/components/Placeholder";
import SEO from "@/utils/SEO";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { colors } from "@/theme/theme";
import { ResultItem } from "@/types";
import useGeolocation from "@/hooks/useGeolocation";

const CATEGORY_COLORS = {
    Activity: "#890077",
    Place: "#00668A",
    Event: "#006E0F",
    Accomodation: "#704700",
    Business: "#5600AD",
};

const StyledSearch = styled.div`
 .leaflet-popup-close-button{
    background : ${colors.primary} !important;
    color : white!important;
    border-radius : 100px !important;
    top : -10px !important;
    right : -10px !important;
 }
 `



const Search = (props) => {

    useGeolocation();

    const url = new URL(window.location.href)
    const { t } = useTranslation(["common", "validation", "glossary"]);
    const { results } = props;
    // State variables
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [isFiltersOpen, setIsFiltersOpen] = useState(false);
    const [resultsData, setResultsData] = useState<ResultItem[]>(props.results.data);
    const [hoveredItem, setHoveredItem] = useState(null);
    //this state keeps if flyToBounds will get triggered
    const [fly, setFly] = useState(false);
    const [isMapView, setIsMapView] = useState(
        url.searchParams.get("isMapView") === "false" ? false : true,
    )

    useEffect(() => {
        setResultsData(results.data);
        setLoading(false);
    }, [results])

    const handleResultsUpdate = (newData) => {
        setResultsData(newData);
    }

    const setSelectedModelType = (modelType: string) => {

        const params = url.searchParams;
        let removed = false;
        const keysToDelete = [];

        // Collect keys to delete
        for (const [key, value] of params.entries()) {
            if (key.startsWith("searchScope[")) {
                if (modelType === "all") {
                    keysToDelete.push(key);
                    removed = true;
                } else if (value === modelType) {
                    keysToDelete.push(key);
                    removed = true;
                    break;
                }
            }
        }

        // Delete collected keys
        for (const key of keysToDelete) {
            params.delete(key);
        }

        if (removed === false && modelType !== "all") {
            params.set("searchScope[]", modelType);
        }
        params.set("page", 1);

        params.set("isMapView", isMapView);

        router.get(url.href);
    }

    return (
        <AppLayout>
            <SEO seo={props.seo} />
            <StyledSearch className={isMapView ? "h-[calc(100vh-80px)] [@media(max-height:500px)]:h-[500px]" : ""}>

                <CategoriesFilter
                    isMapView={isMapView}
                    setSelectedModel={setSelectedModelType}
                    setIsFiltersOpen={setIsFiltersOpen}
                    filters
                    setLoading={setLoading}
                    setIsMapView={setIsMapView}
                />

                <div className="flex flex-col [@media(max-height:850px)]:h-[80%] h-[90%] my-4" >
                    {isMapView ? (
                        <div className="flex flex-1 overflow-hidden ">

                            <SearchItems
                                resultsData={resultsData}
                                meta={props.results.meta}
                                loading={loading}
                                setLoading={setLoading}
                                isMapView={isMapView}
                                setHoveredItem={setHoveredItem}
                            />

                            <div className="xl:w-4/5 w-full z-10 relative">
                                <Map
                                    data={results.data}
                                    onResultsUpdate={handleResultsUpdate}
                                    setLoading={setLoading}
                                    categoryColors={CATEGORY_COLORS}
                                    setPage={setCurrentPage}
                                    hoveredItem={hoveredItem}
                                    fly={fly}
                                    setFly={setFly}
                                />
                            </div>

                        </div>
                    ) : (
                        <div>
                            <h1 className="p-4 text-5xl font-bold dark:text-white text-center">{t("list", { ns: "glossary" })}</h1>
                            {loading ? (
                                <Placeholder length={resultsData.length} />
                            ) : (
                                <>

                                    <ItemsGrid items={resultsData} />
                                    <div className="flex justify-center">
                                        <PaginationComp
                                            meta={props.results.meta}
                                            setLoading={setLoading}
                                            isMapView={isMapView}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                    {/* Filters Modal */}
                    <Filters
                        isOpen={isFiltersOpen}
                        onClose={() => setIsFiltersOpen(false)}
                        setFly={setFly}
                    />
                </div>
            </StyledSearch>
        </AppLayout>
    );
};

export default Search;
